import React from "react";

import { noop } from "lodash";
import uuidv4 from "uuid/v4";

import type { BillingInterval } from "./BillingIntervalToggle";

type BillingContextInterface = {
	analyticsFingerprint: string;
	billingInterval: BillingInterval;
	setBillingInterval: (interval: BillingInterval) => void;
};

export const BillingContext = React.createContext<BillingContextInterface>({
	analyticsFingerprint: uuidv4(),
	billingInterval: "annually",
	setBillingInterval: noop,
});

const analyticsFingerprint = uuidv4();

export const BillingContextProvider: React.FC = props => {
	const [billingInterval, setBillingInterval] = React.useState<BillingInterval>("annually");
	const value = React.useMemo(
		() => ({ analyticsFingerprint, billingInterval, setBillingInterval }),
		[billingInterval, setBillingInterval],
	);

	return <BillingContext.Provider value={value}>{props.children}</BillingContext.Provider>;
};
